import { connect } from 'react-redux';
import { baseDomain } from '../../../../../core/selectors/institution';
import {
  accessingCurrentSpaceAsStaff,
  isInstructorInSpace,
} from '../../../../../core/selectors/classroom';
import fetchAccessTokenAction from '../../../../../core/actions/accessToken/accessToken.action';
import {
  operations as assignmentOperations,
  selectors as assignmentSelectors,
} from '../../../../store/assignments';
import {
  currentUserId,
  needsToRefreshAccessToken,
  accessToken as getAccessToken,
} from '../../../../../core/selectors/user';
import { getCurrentSpaceId } from '../../../../../core/selectors/space';
import AssignmentsResponsive from './AssignmentResponsive';

const resolveAssignmentId = (assignment?: { id?: string; objectId?: string }) =>
  assignment?.id || assignment?.objectId || '';

const getSubmissionsByIds = (getSubmissions, ...ids) => {
  for (const id of ids) {
    if (!id) continue;
    const submissions = getSubmissions(id);
    if (submissions.length) return submissions;
  }
  return [];
};

export const mapStateToProps = (state, ownProps) => {
  const userId = currentUserId(state);
  const spaceId = assignmentSelectors.getSelectedSpaceId(state);
  const currentSpaceId = getCurrentSpaceId(state);

  const needsToRefreshAccessTokenProp = () => {
    return spaceId ? needsToRefreshAccessToken(state, spaceId) : false;
  };
  const isStaff = accessingCurrentSpaceAsStaff(state);

  const urlAssignmentId = ownProps.params?.assignmentId;
  const assignment = assignmentSelectors.getSelectedAssignment(state);
  const resolvedAssignmentId =
    resolveAssignmentId(assignment ?? undefined) || urlAssignmentId || '';
  const getSubmissions = (id) =>
    assignmentSelectors.getAssignmentSubmissions(state, id);
  const parentAssignmentSubmissions = getSubmissionsByIds(
    getSubmissions,
    urlAssignmentId,
    resolvedAssignmentId
  );
  const isGroupAssignment = !!(assignment as any)?.groupSet;
  const hasFetchedSubmissions = assignmentSelectors.hasFetchedSubmissions(
    state,
    resolvedAssignmentId
  );
  const showEmptyCohortAlert =
    !isGroupAssignment &&
    hasFetchedSubmissions &&
    parentAssignmentSubmissions.length === 0;

  const extensions = assignment?.extensions || [];
  const hasExtensions = !!extensions.length;
  const extensionIds = extensions
    .map((e: any) => e.id || e.objectId)
    .filter(Boolean);

  return {
    user: state.user.user,
    selectedSpace: spaceId ? state.data.classRooms[spaceId] : undefined,
    isFetching:
      assignmentSelectors.isFetchingAssignments(state) ||
      state.accessTokens.isFetching,
    accessTokens: state.accessTokens,
    baseDomain: baseDomain(state),
    isEducator: spaceId ? isInstructorInSpace(state)(userId, spaceId) : false,
    needsToRefreshAccessTokenProp,
    isStaff,
    showEmptyCohortAlert,
    _submissionFetchParams: {
      accessToken: getAccessToken(state, currentSpaceId),
      resolvedAssignmentId,
      hasExtensions,
      extensionIds,
      hasFetchedSubmissions,
      isFetchingSubmissions: assignmentSelectors.isFetchingSubmissions(
        state,
        resolvedAssignmentId
      ),
    },
  };
};

export const mapDispatchToProps = (dispatch) => ({
  fetchAssignments: dispatch(assignmentOperations.fetchAssignments),
  fetchAccessToken: fetchAccessTokenAction(dispatch),
  fetchSubmissions: (params) =>
    dispatch(assignmentOperations.fetchSubmissions(params)),
  fetchAllSubmissionsIncludingExtensions: (params) =>
    dispatch(
      assignmentOperations.fetchAllSubmissionsIncludingExtensions(params)
    ),
});

const AssignmentsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignmentsResponsive);

export default AssignmentsContainer;
